import Form from './Form'
import FormInput from './FormInput'
import AddChip from './AddChip'
import DatePicker from './DatePicker'
import CheckBox from './CheckBox'

const Controls = {
    Form, 
    FormInput,
    AddChip,
    DatePicker,
    CheckBox
}

export default Controls